import { render, staticRenderFns } from "./GoogleMyBusinessSettingsCard.vue?vue&type=template&id=40c2ab0e"
import script from "./GoogleMyBusinessSettingsCard.vue?vue&type=script&lang=ts"
export * from "./GoogleMyBusinessSettingsCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports